import { c as _c } from "react/compiler-runtime";
import { renderCardComponent } from '@src/components/sco/InvestorOutreachLP/components/blocks/MasonryGrid';
import SocialProofCard from '@src/components/sco/InvestorOutreachLP/components/cards/SocialProofCard';
import SectionWrapper from '@src/components/sco/LayoutBlocks/SectionWrapper';
import { processCardsData } from '@src/components/sco/utilities/cardUtils';
import React from 'react';

/**
 * SocialProofCardBlock component that renders social proof cards
 *
 * @param props.bgColor - Background color for the section
 * @param props.cards - Custom array of card data (optional when using cardSet)
 * @param props.cardSet - Predefined set of cards to use ('set1', 'set2', or 'custom')
 *
 * @example
 * // Use predefined set 1
 * <SocialProofCardBlock bgColor="background" cardSet="set1" />
 *
 * @example
 * // Use predefined set 2
 * <SocialProofCardBlock bgColor="backgroundSecondary" cardSet="set2" />
 *
 * @example
 * // Use custom cards
 * <SocialProofCardBlock bgColor="background" cards={customCardData} />
 */
export const SocialProofCardBlock = props => {
  const $ = _c(9);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = function renderSocialProofCards(ids) {
      const sortedCards = processCardsData(ids);
      return sortedCards.map(_temp);
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const renderSocialProofCards = t0;
  let cardsToRender;
  if ($[1] !== props.cardSet || $[2] !== props.cards) {
    const cardSets = {
      set1: ["sc8", "bc4", "bc2"],
      set2: ["sc5", "bc3", "bc10"]
    };
    if (props.cardSet === "set1") {
      cardsToRender = renderSocialProofCards(cardSets.set1);
    } else {
      if (props.cardSet === "set2") {
        cardsToRender = renderSocialProofCards(cardSets.set2);
      } else {
        if (props.cards) {
          cardsToRender = props.cards;
        } else {
          cardsToRender = renderSocialProofCards(cardSets.set1);
        }
      }
    }
    $[1] = props.cardSet;
    $[2] = props.cards;
    $[3] = cardsToRender;
  } else {
    cardsToRender = $[3];
  }
  let t1;
  if ($[4] !== cardsToRender) {
    t1 = <SocialProofCard cards={cardsToRender} />;
    $[4] = cardsToRender;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== props.bgColor || $[7] !== t1) {
    t2 = <SectionWrapper bgColor={props.bgColor}>{t1}</SectionWrapper>;
    $[6] = props.bgColor;
    $[7] = t1;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
};
function _temp(data, index) {
  return renderCardComponent(data, index);
}